import { BtBackendProvider } from './../../providers/bt-backend/bt-backend';
import { ViewController, AlertController, LoadingController } from 'ionic-angular';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { InAppBrowser } from '../../../node_modules/@ionic-native/in-app-browser';

/**
 * Generated class for the UserSubscriptionCoinbaseComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'user-subscription-coinbase',
  templateUrl: 'user-subscription-coinbase.html'
})
export class UserSubscriptionCoinbaseComponent {

  @Input('plan') plan: string;
  @Output('processed') processed = new EventEmitter<boolean>(); //False for crypto

  URL: string;

  constructor(
    public viewCtrl: ViewController,
    public iab: InAppBrowser,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public backend: BtBackendProvider
  ) {

  }

  startCoinbase(){
    let alert = this.alertCtrl.create({
      title: 'Pay with crypto',
      message: 'In a moment you will be taken to Coinbase to process your payment. It will take some time to transact, but you can just check the blockchain. Due to the nature of cryptocurrencies, you will have to do this each time you want to renew your subscription. Coinbase will have all the instructions you need but if you have any problems, let us know at support@blocktistics.com.',
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            this.getCharge();
          }
        },
        {
          text: 'Cancel',
          role: 'cancel'
        }
      ]
    })
    alert.present();
  }

  getCharge(){
    let loader = this.loadingCtrl.create();
    loader.present();

    this.backend.getCoinbaseCharge(this.plan).first().subscribe(data => {
      loader.dismiss();
      if(data.hosted_url){
        this.URL = data.hosted_url;
        this.iab.create(this.URL, '_system');
      }
      this.processed.emit(false);
    }, error => {
      console.log(error);
      loader.dismiss();
    })

  }
}



// WEBPACK FOOTER //
// ./src/components/user-subscription-coinbase/user-subscription-coinbase.ts